import { Tooltip as ReactTooltip } from "react-tooltip";
import { classNames } from "../../helpers/classNames";

const Tooltip = ({
  value,
  position = "bottom",
  type,
  message,
  children,
  className,
  messageClass,
}) => {
  const tooltipId = `tooltip-${Math.random().toString(36).substr(2, 9)}`;
  return (
    <>
      <div
        className={classNames("w-fit h-fit", className)}
        data-tooltip-id={tooltipId}
        data-tooltip-position-strategy="fixed"
        data-tooltip-content={message}
      >
        {children ? children : value}
      </div>
      <ReactTooltip
        id={tooltipId}
        place={position}
        variant={type}
        className={classNames(
          "z-70 !text-[10px] !h-fit !px-3 !py-1 font-medium shadow-md",
          messageClass
        )}
      />
    </>
  );
};

export default Tooltip;
